import { useActivityShopUI } from 'hooks/useActivityShopUI';
import { useLocalization } from 'hooks/useLocalization';
import { useBusiness } from 'hooks/useBusiness';

import { FormGroup, FormControlLabel, Switch } from '@mui/material';

import { Activity } from "interfaces/ActivityInterfaces";
import { ActivityInteractionData } from "interfaces/ActivityShopUIInterfaces";
import 'react-day-picker/dist/style.css';

import { formatNumberWithSpacesAndRounding } from 'utils/formatUtils';

interface AddonSwitchesProps {
	activity: Activity;
	selectedActivityTypeTab: 'group' | 'private';
	activityInteractionData: ActivityInteractionData;
}

function AddonSwitches({ activity, selectedActivityTypeTab, activityInteractionData }: AddonSwitchesProps) {
	const { activityAddons } = useBusiness();
	const { selectedCurrencyCode, getTotalPaxQty, paxArr } = useActivityShopUI();
	const { getStr } = useLocalization();
	const { toggleAddonSelection } = useActivityShopUI();

	if (!activityInteractionData) return null;

	function handleAddonChange(addonId: number, event: React.ChangeEvent<HTMLInputElement>) {
		toggleAddonSelection(activity.id, selectedActivityTypeTab, addonId, event.target.checked);
	}

	const availableAddons = activityAddons.filter(activityAddon => 
		activity.addonIds.includes(activityAddon.id) && (
			(selectedActivityTypeTab === 'private' && activityAddon.availableAsTourType.private) ||
			(selectedActivityTypeTab === 'group' && activityAddon.availableAsTourType.group)
		)
	);

	return (
		<>
			<div style={{ height: '20px' }} />
			{
				availableAddons.map(activityAddon => {
					// Determine if the switch should be checked
					const addonInteractionData = activityInteractionData?.addons[selectedActivityTypeTab].find(addonInSelection => addonInSelection.addonId === activityAddon.id);
					
					if (!addonInteractionData) {
						throw new Error('Addon interaction data not found');
					}
	
					const isChecked = addonInteractionData.isAdded ?? false;

					if (!selectedCurrencyCode) return null;
					
					return (
						<FormGroup key={activity.id + '_' + activityAddon.id + '_' + selectedActivityTypeTab} sx={{ marginBottom: '20px' }}>
							<FormControlLabel
								control={
									<Switch
										onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleAddonChange(activityAddon.id, event)}
										checked={isChecked}
										disabled={
											(activityInteractionData.isAdded && activityInteractionData.addedAs !== selectedActivityTypeTab) ||
											!addonInteractionData.totalPrice
										}
									/>
								}
								label={
									<div style={{ display: 'flex', alignItems: 'center', gap: '20px', paddingLeft: '15px' }}>
										{!!activityAddon.imageUrl && (
											<img src={activityAddon.imageUrl} alt={activityAddon.title} style={{ width: '60px', height: '60px' }} />
										)}
										<div style={{ display: 'flex', flexDirection: 'column' }}>
										<div style={{ fontWeight: 'bold' }}>{activityAddon.title}</div>
										<div style={{ fontSize: '0.8em', fontWeight: 'bold' }}>
											{
												addonInteractionData.totalPrice ? (
													<div>
														{formatNumberWithSpacesAndRounding(addonInteractionData.totalPrice / getTotalPaxQty(paxArr))} {selectedCurrencyCode} {getStr('PER_PERSON_ABBREV')}
													</div>
												) : (
													<div style={{ color: 'red' }}>{getStr('Price_unset').toUpperCase()}</div>
												)
											}
										</div>
										<div className="tt-description-line">{activityAddon.descShort}</div>
										</div>
									</div>
									}
							/>
						</FormGroup>
					);
				})
			}
		</>
	);
}

export default AddonSwitches;